import React, { useState, useEffect } from "react";

import { Modal, Button } from "react-bootstrap";

import axios from "axios"; // Import Axios

 

const FeedbackModalForm = ({ handleClose, question, answer, feedbackType, interaction }) => {

  const [showModal, setShowModal] = useState(true);

  const [feedback, setFeedback] = useState("");

  const [feedbackError, setFeedbackError] = useState(false);

  const [ipAddress, setIPAddress] = useState('');

  const [isNegativeFeedbackSelected, setIsNegativeFeedbackSelected] = useState(

    feedbackType === "negative"

  );

  useEffect(() => {
    // Fetch and log IPAddress when FeedbackComponent mounts
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIPAddress(data.ip))
      .catch(error => console.log(error))
  }, []);
 

  const handleShowModal = () => setShowModal(!showModal);

 

  const handleCloseModal = () => {

    // Reset the feedback type and deselect the thumbs-down button

    setIsNegativeFeedbackSelected(false);

 

    // Close the modal after resetting

    handleShowModal();

 

    // Reset the feedback type when the modal is closed without submission

    handleClose();

  };

 

  const handleSubmitFeedback = () => {

    // Check if the feedback is required (negative feedback) and if the feedback is empty

    if (feedbackType === "negative" && !feedback.trim()) {

      // Show error only when trying to submit negative feedback

      setFeedbackError(true);

      return;

    }

 

    // Prepare the formData with feedback content

    // const formData = {

    //   question,

    //   answer,

    //   feedbackType, // Set feedbackType to either "positive" or "negative"

    //   feedback, // Include feedback regardless of whether it's positive or negative

    // };

    const formData = {

      question,

      answer,

      feedback: feedbackType === "negative" ? "negative" : "positive",

      feedbackComment: feedbackType === "negative" ? feedback : "",

      interaction, // Include feedback only for negative feedback

      ipAddress,

    };

   

    // Send feedback data to the server

   

    axios

      .post("https://ai.mosip.sandbox.stataware.com/qa/feedback/newqna/_doc", formData)

      .then((response) => {

       

        console.log("Response Data:", response.data);

       

        // Close the modal after successfully submitting feedback

        handleCloseModal();

      })

      .catch((error) => {

        console.error("Error posting feedback:", error);

      });

   

  };

 

  useEffect(() => {

    // Update the thumbs-down button state based on feedbackType

    setIsNegativeFeedbackSelected(feedbackType === "negative");

  }, [feedbackType]);

 

  return (

    <Modal show={showModal} onHide={handleCloseModal} className="feedback-modal">

      <Modal.Header closeButton>

        <Modal.Title style={{ color: isNegativeFeedbackSelected && feedbackError ? "red" : "" }}>

          {isNegativeFeedbackSelected ? "Feedback Negative" : "Feedback"}

        </Modal.Title>

      </Modal.Header>

 

      <Modal.Body>

        <h6 style={{ marginBottom: "20px" }}>Please provide your feedback:</h6>

 

        <textarea

          value={feedback}

          onChange={(e) => {

            setFeedback(e.target.value);

            setFeedbackError(false); // Clear error when the user types in the textarea

          }}

          className={`negative-feedback-textarea ${

            feedbackError ? "feedback-error" : ""

          }`}

          style={{ width: "100%", marginBottom: "20px" }}

          rows={5}

        ></textarea>

 

        {feedbackError && (

          <p className="feedback-error-message">Feedback is required</p>

        )}

 

        {isNegativeFeedbackSelected && (

          <Button

            className="negative-feedback-submit"

            variant="danger"

            onClick={handleSubmitFeedback}

          >

            Submit

          </Button>

        )}

 

        <Button

          className="negative-feedback-close"

          variant="secondary"

          onClick={handleCloseModal}

        >

          Close

        </Button>

      </Modal.Body>

    </Modal>

  );

};

 

export default FeedbackModalForm;
// import React, { useState } from "react";

// import { Modal, Button } from "react-bootstrap";

// import "../src/App.css";

// const FeedbackModalForm = ({ handleClose, question, answer, feedbackType }) => {
//   const [showModal, setShowModal] = useState(true);

//   const [feedback, setFeedback] = useState(""); // State to hold feedback text

//   const [feedbackError, setFeedbackError] = useState(false);

//   // console.log("Selected feedback type:", feedbackType);

//   // Use setShowModal to toggle modal visibility

//   const handleShowModal = () => setShowModal(!showModal);

//   const handleCloseModal = () => {
//     // if (feedbackType === "negative" && !feedback.trim()) {
//     //   setFeedbackError(true); // Show error if feedback is empty

//     //   return;
//     // }

//     // if (feedbackType === "negative") {
//     //   console.log("Negative Feedback:", feedback); // Print negative feedback to the console
//     // } else {
//     //   console.log("Positive Feedback:", feedback); // Print feedback to the console
//     // }

//     handleShowModal(); // Toggle modal visibility

//     handleClose(); // Call the provided handleClose function to close the parent modal
//   };

//   if (feedbackType == "negative") {
//     return (
//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         className="feedback-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title style={{ color: "red" }}>Feedback Negative</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <h6 style={{ marginBottom: "20px" }}>
//             Please provide your feedback:
//           </h6>

//           <textarea
//             value={feedback}
//             onChange={(e) => {
//               setFeedback(e.target.value);

//               setFeedbackError(false); // Clear error when user types in the textarea
//             }}
//             //className={feedbackError ? "feedback-error" : ""}

//             className={`negative-feedback-textarea ${
//               feedbackError ? "feedback-error" : ""
//             }`}
//             style={{ width: "100%", marginBottom: "20px" }} // Set the width to 100% to make it full length
//             rows={5} // Specify the number of rows
//           ></textarea>

//           {feedbackError && (
//             <p className="feedback-error-message">Feedback is required</p>
//           )}

//           <Button
//             className="negative-feedback-submit"
//             variant="danger"
//             onClick={handleCloseModal}
//           >
//             Submit
//           </Button>

//           <Button
//             className="negative-feedback-close"
//             variant="secondary"
//             onClick={handleCloseModal}
//           >
//             Close
//           </Button>
//         </Modal.Body>
//       </Modal>
//     );
//   } else {
//     return (
//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         className="feedback-modal"
//         value={feedback}
//         onChange={(e) => {
//           setFeedback(e.target.value);

//           setFeedbackError(false); // Clear error when user types in the textarea
//         }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Feedback</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p>Please provide your feedback:</p>

//           <textarea></textarea>

//           <Button variant="success" onClick={handleCloseModal}>
//             Submit Negative Feedback
//           </Button>

//           <Button variant="secondary" onClick={handleCloseModal}>
//             Close
//           </Button>
//         </Modal.Body>
//       </Modal>
//     );
//   }
// };

// export default FeedbackModalForm;
